import React, { useEffect, useRef } from 'react';

import classNames from 'classnames';

import Tooltip from '../../Tooltip';

export default function Textarea({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  touched,
  tabindex,
  isVisible,
  readOnly,
  tooltip,
  className,
  rows,
  maxLength,
  placeholder,
  style,
}) {
  const inputRef = useRef();

  // Focus on input if tabindex = 1
  useEffect(() => {
    if (tabindex === 1) {
      inputRef.current.focus();
    }
  }, [tabindex, isVisible]);

  return (
    <div className={className} style={style}>
      <label
        className="flex text-sm font-medium mb-1 items-center gap-2"
        htmlFor={name}
      >
        {label}{' '}
        {tooltip && (
          <Tooltip position="right" fixed>
            {tooltip}
          </Tooltip>
        )}
      </label>
      <textarea
        maxLength={maxLength}
        ref={inputRef}
        className={classNames('form-textarea w-full focus:border-slate-300', {
          'border-none shadow-none resize-none': readOnly,
        })}
        rows={rows || (readOnly ? 2 : 3)}
        placeholder={readOnly ? '' : placeholder}
        spellCheck="false"
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        tabIndex={tabindex}
        readOnly={readOnly}
      />
      {error && touched && (
        <div className="text-red-500 text-sm mt-1">{error}</div>
      )}
    </div>
  );
}
